import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import {
  FormError,
  FormErrors,
  ServerError,
  UnknownError,
} from "@/models/error";
import { computed } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
    error: null
  },
  setup(__props: any) {

const props = __props as {
  error?: unknown;
};



const message = computed(() => {
  let errors: string[] = [];
      if (typeof props.error == "string") {
        errors = [props.error];
      } else {
        if (props.error instanceof FormError) {
          errors = [props.error?.message];
        } else if (props.error instanceof FormErrors) {
          // Only globalss
          //console.log(props.error);
          errors = Object.values(props.error.global).map((v) => v.message);
          console.log(props.error.global)
        } else if (props.error instanceof ServerError) {
          errors = [props.error?.detail];
        } else if (props.error instanceof UnknownError) {
          errors = [props.error?.message];
        }
      }

      return errors;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(message), (v, k) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "error",
      key: k
    }, _toDisplayString(v), 1))
  }), 128))
}
}

})